<template>
  <div class="row">
    <div class="col-12">
      <form role="form">
        <div class="form-group row">
          <label class="pl-4 col-sm-2 col-form-label">{{ $t("type") }}</label>
          <div class="col-sm-10">
            <label class="w-100">
              <select
                name="parameter_type"
                style="width: 100%"
                class="form-control"
                v-model="parameter.parameter_type_id"
                v-validate="'required'"
              >
                <option v-for="(type, i) in types_id" :value="type.id" :key="i">
                  {{ type.name }}
                </option>
              </select>
              <small v-show="errors.has('parameter_type')" class="text-danger">
                {{ $t("field_required") }}
              </small>
            </label>
          </div>
        </div>
        <div class="hr-line-dashed"></div>
        <div class="mb-4 text-md">{{ $t("names_different_langs") }}:</div>
        <div v-for="(l, i) in langsFormData" class="form-group row">
          <label class="pl-4 col-sm-2 col-form-label">{{
            l.lang.toUpperCase()
          }}</label>
          <div class="col-sm-10">
            <input
              type="text"
              :name="'langValue-' + l.lang"
              v-model="l.value"
              class="form-control"
              v-validate="'required'"
            />
            <small
              v-show="errors.has('langValue-' + l.lang)"
              class="text-danger"
            >
              {{ $t("field_required") }}
            </small>
          </div>
        </div>
        <div class="hr-line-dashed"></div>
      </form>
      <div class="col-sm-12">
        <div
          v-if="editModel && this.roles.id === 1"
          class="btn mx-sm-2 mx-md-0 my-2 btn-danger d-block d-md-inline-block"
          @click.prevent="deleteParam()"
        >
          {{ $t("remove_parameter") }}
        </div>
        <div
          type="submit"
          class="
            btn
            mx-md-2
            my-2
            btn-primary
            d-block d-md-inline-block
            float-md-right
          "
          v-text="
            editModel ? this.$t('update_parameter') : this.$t('save_parameter')
          "
          @click.prevent="saveParam()"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ParametersForm',
  data() {
    return {
      defaultLangs: [ 'pl', 'en', 'de', 'es', 'fr', 'it' ],
      editModel: false,
      parameter: {
        parameter_type_id: '',
        lang: []
      },
      types_id: [],
      langsFormData: []
    }
  },
  computed: {
    ...mapGetters( 'users', [ 'roles' ] )
  },
  async created() {
    this.$emit( 'loading', true )
    await this.getTypes()
    if ( this.$route.params.id !== undefined ) {
      await this.getData()
      this.editModel = true
    }
    this.createdLangsFormData()
    this.$emit( 'loading', false )
  },
  methods: {
    getData() {
      this.$emit( 'loading', true )
      return this.$http
        .get(
          `vnfr/${this.$route.params.env}/parameters/${this.$route.params.id}`
        )
        .then( resp => {
          this.parameter = resp.data.parameter
          return true
        } )
        .catch( err => {
          this.$toastr.error( err )
          return false
        } )
    },
    createdLangsFormData() {
      this.defaultLangs.forEach( lang => {
        const elementIndex = this.parameter.lang.findIndex( element => element.lang == lang )
        if ( elementIndex !== -1 ) {
          this.langsFormData.push( this.parameter.lang[ elementIndex ] )
        } else {
          this.langsFormData.push( this.createDefaultLangsData( lang ) )
        }
      } )
    },
    createDefaultLangsData( lang ) {
      return {
        id: null,
        lang: lang,
        value: ''
      }
    },
    getTypes() {
      return this.$http
        .get( `vnfr/${this.$route.params.env}/parameters-types` )
        .then( resp => {
          this.types_id = resp.data.table
          return true
        } )
        .catch( err => {
          this.$toastr.error( err )
          return false
        } )
    },
    deleteParam() {
      this.$emit( 'loading', true )
      this.$http
        .delete(
          `vnfr/${this.$route.params.env}/parameters/${this.$route.params.id}`
        )
        .then( resp => {
          this.$toastr.success( 'Usunięte!!' )
          this.$emit( 'loading', false )
          this.$router.push(
            `/przymierzalnia/${this.$route.params.env}/parametry`
          )
        } )
        .catch( err => {
          this.$toastr.error( err )
          this.$emit( 'loading', false )
        } )
    },
    saveParam() {
      this.$validator.validateAll().then( result => {
        if ( result ) {
          this.$emit( 'loading', true )
          const url = `vnfr/${this.$route.params.env}/parameters/${this.$route.params.id}`
          this.parameter.lang = this.langsFormData
          this.$http( {
            url:
              this.$route.params.id !== undefined
                ? url
                : `vnfr/${this.$route.params.env}/parameters/`,
            method: this.$route.params.id !== undefined ? 'put' : 'post',
            data: this.parameter
          } )
            .then( resp => {
              this.$toastr.success( 'Zapisane!!' )
              this.$emit( 'loading', false )
                this.$router.push(
                  `/przymierzalnia/${this.$route.params.env}/parametry`
                )
            } )
            .catch( err => {
              this.$toastr.error( err )
              this.$emit( 'loading', false )
            } )
        }
      } )
    }
  }
}
</script>

<style scoped>

a {
  color: white;
}
.text-md {
  font-size: 14px;
}
</style>
